import { useEffect, useState } from "react";
import { api, apiError } from "../lib/apiClient";
import { toast } from "sonner";
import { BrainCircuit, Loader2, Save } from "lucide-react";

// Admin: pick the Claude model (via Emergent key) used for Studio code-gen + e-mail
// drafting/triage. Sara's main conversational brain (Agnes) is a separate engine.
export function LlmModelPanel() {
  const [cfg, setCfg] = useState(null);
  const [model, setModel] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api
      .get("/admin/llm-config")
      .then(({ data }) => { setCfg(data); setModel(data.model); })
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/llm-config", { model });
      setCfg((c) => ({ ...c, model, updated_by: "vous" }));
      toast.success("Modèle IA mis à jour — appliqué immédiatement");
    } catch (e) {
      toast.error(apiError(e, "Impossible d'enregistrer"));
    } finally {
      setSaving(false);
    }
  };

  if (!cfg) return null;
  const dirty = model !== cfg.model;

  return (
    <div className="hud-panel clip-corner p-5 sm:p-6" data-testid="admin-llm-panel">
      <div className="flex items-center gap-2 mb-1">
        <BrainCircuit className="h-5 w-5 accent-text" />
        <h3 className="font-display text-base font-black tracking-[0.1em] text-white">MODÈLE IA — STUDIO & E-MAILS</h3>
      </div>
      <p className="font-mono-hud text-[10.5px] text-[#8b949e] leading-relaxed mb-4">
        Modèle Claude (clé Emergent) utilisé pour la génération de code du Studio et la rédaction / tri des e-mails.
        Le cerveau conversationnel de Sara (Agnes) n'est pas affecté.
      </p>
      <div className="flex flex-col sm:flex-row sm:items-end gap-3">
        <div className="flex-1 min-w-0">
          <label className="font-mono-hud text-[10px] tracking-[0.2em] uppercase text-[#6b7a8d] mb-1 block">Modèle actif</label>
          <select
            data-testid="llm-model-select"
            value={model}
            onChange={(e) => setModel(e.target.value)}
            className="hud-input w-full text-[13px] py-2.5"
          >
            {cfg.options.map((o) => (
              <option key={o.id} value={o.id} className="bg-[var(--panel-solid)] text-white">
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <button
          data-testid="llm-model-save"
          onClick={save}
          disabled={saving || !dirty}
          className="hud-btn clip-corner px-5 py-2.5 text-[12px] font-bold flex items-center gap-2 disabled:opacity-50 shrink-0"
        >
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Enregistrer
        </button>
      </div>
      {cfg.updated_by && (
        <p className="font-mono-hud text-[9.5px] text-[#6b7a8d] mt-2" data-testid="llm-model-updated">
          Dernière modification par {cfg.updated_by}
        </p>
      )}
    </div>
  );
}
